import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

const NavigationDropdownDrawerButton = (props) => {
  const { label, onClick, onKeyDown, ...rest } = props;

  const handleKeyDown = (event) => {
    const key = event.key || event.keyCode;
    const isSpace = key === ' ' || key === 'Spacebar' || key === 32;
    const isEnter = key === 'Enter' || key === 13;

    if (isSpace || isEnter) {
      event.stopPropagation();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  return (context) => (
    <Button
      className="NavigationDropdownDrawerButton"
      onClick={() => onClick(context)}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {label}
    </Button>
  );
};

NavigationDropdownDrawerButton.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
};

export default NavigationDropdownDrawerButton;
